import { render } from "./ZakhirLp.vue?vue&type=template&id=72e281f2"
import script from "./ZakhirLp.vue?vue&type=script&lang=js"
export * from "./ZakhirLp.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__